import { useTranslation } from 'react-i18next'
import { outlinedInputClasses } from '@mui/material'
import MenuItem from '@mui/material/MenuItem'
import { FormikTextField } from 'components/Formik/FormikTextField'
import { RequiredDot } from 'pages/Survey/components/RequiredDot'
import { DropDownQuestion } from 'pages/Survey/types'
import { useLangContext } from 'store/useLangContext'
import { useGetObjectTranslation } from 'utils/useGetObjectTranslation'

export const SurveyDropdown = ({ question }: { question: DropDownQuestion }) => {
  const translatedTitle = useGetObjectTranslation(question.translation, 'title')
  const { i18n } = useTranslation()
  const { languages } = useLangContext()
  const defaultLangCode = languages?.find((lang) => lang.default)?.language.code

  return (
    <FormikTextField
      select
      name={question.id}
      label={
        <>
          {translatedTitle}
          {question.isRequired ? <RequiredDot /> : ''}
        </>
      }
      fullWidth
      variant="outlined"
      size="small"
      sx={{
        [`& .${outlinedInputClasses.root}`]: { background: (theme) => `${theme.palette.background.paper}!important` },
      }}
      required={question.isRequired}
    >
      {question.options.map((option) => (
        <MenuItem key={option.id} value={option.id}>
          {option.translation?.[i18n.language]?.title ||
            option.translation?.en?.title ||
            option.translation?.[defaultLangCode]?.title ||
            ''}
        </MenuItem>
      ))}
    </FormikTextField>
  )
}
